import {useState} from 'react'

import PropTypes from 'prop-types'

import {SLIDER_IMAGE_DESIGNS, SLIDER_VIDEO_BASE_CLASS} from '../../../config.js'
import VideoPlayer from './Player.js'
import Thumbnail from './Thumbnail.js'

const Video = ({
  autoPlay: autoPlayProp,
  currentSlide,
  displayVideoControls,
  firstImage,
  index,
  onVideoClick,
  onVideoPlay = () => null,
  sliderImageDesign,
  url,
  videoApiRef,
  manualPlay = false,
  timeOffset,
  title
}) => {
  const [hasManuallyPaused, setHasManuallyPaused] = useState(false)
  const [isVideoPlaying, setIsVideoPlaying] = useState(manualPlay)
  const [autoPlay, setAutoPlay] = useState(autoPlayProp)

  const videoThumbnail = (
    <Thumbnail
      currentSlide={currentSlide}
      firstImage={firstImage}
      index={index}
      sliderImageDesign={sliderImageDesign}
      onVideoPlay={e => {
        e.preventDefault()
        setIsVideoPlaying(true)
      }}
    />
  )

  const forcePauseVideo = () => {
    setHasManuallyPaused(true)
    setIsVideoPlaying(false)
    setAutoPlay(!autoPlay)
  }
  const videoComponent =
    (autoPlay && currentSlide === index) || (isVideoPlaying && currentSlide === index) || hasManuallyPaused ? (
      <VideoPlayer
        autoPlay={autoPlay && currentSlide === index}
        currentSlide={currentSlide}
        displayVideoControls={displayVideoControls}
        isVideoPlaying={isVideoPlaying}
        index={index}
        onVideoClick={displayVideoControls ? forcePauseVideo : onVideoClick}
        onVideoPlay={onVideoPlay}
        url={url}
        videoApiRef={videoApiRef}
        timeOffset={timeOffset}
        title={title}
        fallback={videoThumbnail}
      />
    ) : (
      videoThumbnail
    )

  return <div className={SLIDER_VIDEO_BASE_CLASS}>{videoComponent}</div>
}

Video.displayName = 'Video'
Video.propTypes = {
  autoPlay: PropTypes.bool,
  displayVideoControls: PropTypes.bool,
  url: PropTypes.string,
  firstImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    key: PropTypes.string,
    title: PropTypes.string,
    fetchpriority: PropTypes.string
  }).isRequired,
  onVideoClick: PropTypes.func,
  onVideoPlay: PropTypes.func,
  sliderImageDesign: PropTypes.oneOf(Object.values(SLIDER_IMAGE_DESIGNS)),
  index: PropTypes.string,
  currentSlide: PropTypes.number,
  videoApiRef: PropTypes.object,
  manualPlay: PropTypes.bool,
  timeOffset: PropTypes.number,
  title: PropTypes.string
}

export default Video
